<template>
  <div class="orderContent">
    <div class="remind">
      <!-- <div v-if="needChangehandler === 2">医生意向时间：{{ businessDate }}</div> -->
      <div v-if="prop.isBatch">
        本次批量修改会对工单内所有未修改复诊日期的患者生效，请确认与医生充分沟通好。
      </div>
      <div v-else>请分别与医生、患者确认时间再填写</div>
    </div>
    <RetreatForm ref="reFormRef" :isBatch="prop.isBatch" :itemInfo="prop.itemInfo" />
  </div>
</template>

<script setup>
import { ref, defineExpose, defineProps } from 'vue'
import RetreatForm from './retreatForm.vue'

const prop = defineProps({
  itemInfo: {
    type: Object,
    default: () => {}
  },
  isBatch: {
    type: Boolean,
    default: false
  }
})

const reFormRef = ref()
const submitForm = () => {
  return reFormRef.value.submitValidQuery()
}
defineExpose({
  submitForm
})
</script>
<style lang="scss" scoped>
.orderContent {
  padding: 20px 24px 0px;
  position: relative;

  .remind {
    font-weight: 500;
    font-size: 14px;
    color: #ffa940;
    margin-bottom: 20px;
  }
}
</style>
